import Tree from './Tree';
export default Tree;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/tree/index.js
// module id = 861
// module chunks = 0